export const ACCOUNT_STATUS_ACTIVE = "active";
export const ACCOUNT_STATUS_INACTIVE = "inacitve";

export const ACCOUNT_STATUSES = [
  ACCOUNT_STATUS_ACTIVE,
  ACCOUNT_STATUS_INACTIVE,
] as const;
